import BackTop from './BackTop.vue';

export default BackTop;
